export default {
  notFound: 'برگه یافت نشد',
  NewPageAdded: 'برگه جدید افزوده شد',
  PageUpdated: 'برگه به روز رسانی شد',
  PageRemoved: 'برگه حذف شد',
  ViewPage: 'مشاهده برگه'
}
